import { Row, Col } from 'react-bootstrap'
import { Container } from 'react-bootstrap'

import styles from './OurMission.module.scss'

export default function OurMission() {
    return (
        <Container>
            <section className="p-0">
                <h2 className="mb-5 h1">Our Mission</h2>
                <Row className="mb-6">
                    <Col md={7}>
                        <p>
                            Lead the era of distributed computing by giving every organization access to
                            state-of-the-art technologies and services.
                        </p>
                    </Col>
                </Row>
                <div className={styles.gridContainer}>
                    <div className="d-flex w-100">
                        <div className="">
                            <h2 className="h1">
                                <span className="text-red"> 20</span>
                            </h2>
                            <p>languages spoken</p>
                        </div>
                    </div>
                    <div className={styles.vl}></div>
                    <div className="d-flex w-100">
                        <div>
                            <h2 className="h1">
                                <span className="text-purple"> 18</span>
                            </h2>
                            <p>different countries where our team members are located</p>
                        </div>
                    </div>
                    <div className={styles.vl}></div>
                    <div className="d-flex w-100">
                        <div>
                            <h2 className="h1">
                                <span className="text-green"> 93</span>
                            </h2>
                            <p>93 percent annual team member retention</p>
                        </div>
                    </div>
                </div>
            </section>
        </Container>
    )
}
